// extracted by mini-css-extract-plugin
module.exports = {"textarea":"CommentForm_textarea__3HeTK","container":"CommentForm_container__3ZcVr","btn":"CommentForm_btn__340vT"};